'use client';
import { SelectInput } from '@curology/ui-components-web/react/SelectInput';
import { SelectOption } from '@curology/ui-components-web/react/SelectInput/SelectOption';
import React, { useState } from 'react';

import { type ShippingAddressFields } from '@/types/productSelectionAndCheckout/types';
import { AnalyticsEvent, trackEvent } from '@/utils/analytics';

const ShippingAddressSelectInput: React.FC<{
  fieldEnteredFieldName: string;
  fieldEnteredOrderNumber: number;
  format?: RegExp;
  id: string;
  label: string;
  options: {
    [key: number | string]: string;
  };
  required?: boolean;
  setShippingAddressFields: React.Dispatch<
    React.SetStateAction<ShippingAddressFields>
  >;
  shippingAddressFields: ShippingAddressFields;
}> = ({
  fieldEnteredFieldName,
  fieldEnteredOrderNumber,
  format,
  id,
  label,
  options,
  required,
  setShippingAddressFields,
  shippingAddressFields,
}) => {
  const [hasBeenInteractedWith, setHasBeenInteractedWith] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const canShowAnError = hasBeenInteractedWith && !isFocused;

  const showRequiredError =
    canShowAnError && required && shippingAddressFields[id].trim() === '';

  let hasFormatError = false;

  if (format) {
    hasFormatError =
      shippingAddressFields[id].trim() !== '' &&
      !format.test(shippingAddressFields[id]);
  }

  const showFormatError = canShowAnError && hasFormatError;

  let helperText;

  if (showRequiredError) {
    helperText = `The ${label} field is required.`;
  }

  if (showFormatError) {
    helperText = `The ${label} field is invalid.`;
  }

  const showError = showRequiredError || showFormatError;
  const state = showError ? 'critical' : '';

  return (
    <SelectInput
      helperText={helperText}
      id={id}
      label={label}
      onBlur={(event) => {
        setIsFocused(false);

        trackEvent(AnalyticsEvent.FIELD_ENTERED, {
          field: fieldEnteredFieldName,
          orderNumber: fieldEnteredOrderNumber,
          value: event.target.value.length.toString(),
        });
      }}
      onChange={(e) => {
        setShippingAddressFields({
          ...shippingAddressFields,
          [id]: e.target.value,
        });
      }}
      onFocus={() => {
        setHasBeenInteractedWith(true);
        setIsFocused(true);
      }}
      required={required}
      state={state}
      value={shippingAddressFields[id]}
    >
      {Object.keys(options).map((key) => {
        return (
          <SelectOption key={key} value={key}>
            {options[key]}
          </SelectOption>
        );
      })}
    </SelectInput>
  );
};

export default ShippingAddressSelectInput;
